import { TextField, TextFieldProps } from '@mui/material';
import { IMaskMixinProps, useIMask } from 'react-imask';

type MaskProps = IMaskMixinProps<HTMLInputElement>;

export type MaskedTextFieldProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  maskProps: MaskProps;
  value?: string;
  onChange?: (unmaskedValue: string) => void;
};

export const MaskedTextField = ({
  maskProps,
  value: initialValue,
  onChange,
  ...textFieldProps
}: MaskedTextFieldProps) => {
  const { ref, value } = useIMask(maskProps, {
    defaultValue: initialValue,
    onAccept: (_value, mask) => {
      onChange?.(mask.unmaskedValue);
    },
  });

  return <TextField {...textFieldProps} inputRef={ref} value={value} />;
};
